import { ITotal } from '~shared/modules/cart/models';
import { GaTrackingCheckoutService } from '~shared/modules/ga-tracking/utils/ga-tracking-checkout.service';
import { CartOfferLine } from '~shared/modules/shopping-cart-store';
import { ApplicationEventType } from '../constants';
import { ApplicationEvent } from './application-event.model';
export class CheckoutAddShippingInfoApplicationEvent implements ApplicationEvent {
  type = ApplicationEventType.AddShippingInfo;

  constructor(
    private cartOfferLines: CartOfferLine[],
    private total: ITotal,
    private priceType: string,
    private discountCode?: string,
  ) {}

  getPayload(): any {
    return {
      currency: 'EUR',
      ...GaTrackingCheckoutService.getAuthorizeFlow,
      coupon: this.discountCode,
      value: this.total?.total ? +this.total.total : null,
      price_type: this.priceType,
      items: GaTrackingCheckoutService.getItemsForApplicationEvent(this.cartOfferLines),
    };
  }
}
